<template>
  <no-ssr>
    <popup v-model="visible" size="sm" class-name="popup-individual-suggest">
      <div class="popup-individual-suggest__container u-text-center">
        <div class="popup-individual-suggest__icon">
          <svg-inline>
            <icon icon="alarm-circle" />
          </svg-inline>
        </div>
        <div class="font-h1" v-html="$t('popupIndividual.suggest.title')"></div>
        <div
          class="popup-individual-suggest__text font-semibold"
          v-html="$t('popupIndividual.suggest.text')"
        ></div>
        <Button
          class="u-w-full"
          tag="button"
          type="button"
          color="gray"
          :text="$t('popupIndividual.suggest.button')"
          @click="visible = false"
        />
      </div>
    </popup>
  </no-ssr>
</template>

<script>
import Cookies from "js-cookie";
import Popup from "@/components/ui-kit/popup/index.vue";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";
import Button from "@/components/ui-kit/button/index.vue";
import noSSR from "vue-no-ssr";

export default {
  components: {
    Popup,
    SvgInline,
    Icon,
    Button,
    "no-ssr": noSSR,
  },
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      cookieName: "private-tour-suggestion-shown",
    };
  },
  computed: {
    visible: {
      get() {
        return this.modelValue && !Cookies.get(this.cookieName);
      },
      set(value) {
        // write cookie on close
        if (!value) {
          Cookies.set(this.cookieName, true, { expires: 1 });
        }

        this.$emit("change", value);
      },
    },
  },
  watch: {
    modelValue(modelValue) {
      if (modelValue && !this.visible) {
        this.$emit("change", false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-individual-suggest {
  &__container {
    > * + * {
      margin-top: 16px;
    }
  }

  &__icon {
    max-width: 64px;
    margin-right: auto;
    margin-left: auto;
  }

  &__text {
    padding: 0 4%;
    font-weight: normal;
  }
}
</style>
